import {
  TokenData,
  VendorTokenData,
} from "@src/sudozi-schemas/token-data-schemas";
import { createContext } from "react";

export type UseAuthType = {
  tokenUserData: TokenData | null;
  vendorUser: VendorTokenData | null;
  updateCurrentUserState: () => Promise<void>;
  removeToken: () => void;
  error: string;
  loadedJwt: boolean;
};
/* eslint-disable @typescript-eslint/no-empty-function */
// Create placeholder context here. This gets immediately replaced in the AuthProvider component below.
export const authContext = createContext<UseAuthType>({
  error: "",
  removeToken: () => {},
  tokenUserData: null,
  vendorUser: null,
  updateCurrentUserState: async () => {},
  loadedJwt: false,
});
